<template>
  <BbSelectList
    :label="fieldConfig.name"
    class="filters-dropdown"
    size="small"
    width="220px"
    :model-value="selectedValue"
    @update:model-value="onSelectChange"
  >
    <template #default>
      <BbSelectListItem
        v-for="(item, index) in fieldConfig.optionList"
        :key="index"
        :label="item.label"
        :value="item.value"
        size="small"
      >
        {{ item.label }}
      </BbSelectListItem>
    </template>
  </BbSelectList>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    fieldConfig: {
      type: Object,
      default: () => {},
      required: true,
    },
    values: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const selectedValue = computed({
      get: () => props.values[props.fieldConfig.id]?.[0] || '',
      set: (val) => {
        emit('change', { id: props.fieldConfig.id, value: val ? [val] : [] });
      },
    });

    const onSelectChange = (val) => {
      selectedValue.value = val;
    };

    return {
      selectedValue,
      onSelectChange,
    };
  },
};
</script>
<style scope lang="scss">
.filters-dropdown {
  .filters-dropdown {
    .bb-select-list__dropdown .el-select-dropdown .el-select-dropdown__item:first-child {
      font-style: italic;
    }
  }
}
</style>
